import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClient, HttpClientModule} from '@angular/common/http';

import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';

import {MatInputModule} from '@angular/material/input';
import {MatBadgeModule} from '@angular/material/badge';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatListModule} from '@angular/material/list';

import {Language} from './language';

import {
	FormComponent,
	AlertComponent,
	SelectComponent,
	CheckboxComponent,
	PreloaderComponent,
	BurgerMenuComponent,
	PanelInputComponent,
	DatepickerComponent,
	RadioGroupComponent,
	AsyncButtonComponent,
	AmountInputComponent,
	SlideToggleComponent,
	AutocompleteComponent,
	PasswordInputComponent,
	YearDatepickerComponent,
	UploadDocumentComponent,
	PhoneAutocompleteComponent,
	LockableDatepickerComponent,
	CountryAutocompleteComponent,
	DialogComponent,
	PaginationComponent,
	StepperComponent
} from './components';

import {
	DocumentStatusPipe,
	FormatDecimalPipe,
	IndividualGreetingPipe,
	LinkedAccountStatusPipe,
	OrderStatusPipe,
	SanitizeHtmlPipe,
	ProductNamePipe,
	PriceTypePipe,
	DocumentIconPipe,
	DocumentTypePipe,
	FormatCurrencyPipe,
	ProductStatusPipe,
	FormatPercentagePipe,
	ImageCdnFilePipe,
	ProductGroupPipe,
	ProductUnderlyingsPipe,
	ProductSubTypePipe,
	ProductBarrierTypePipe,
	ProductBarrierFrequencyPipe,
	ProductDocumentsPipe,
	OptionsWithHitsPipe,
	ProductCategoryPipe,
	ProductWarrantTypePipe,
	FormatStringPipe,
	IsMutualFundsPipe,
	FormatIntegerPipe,
	OrderTypePipe, ProductCouponPaymentDatePipe, ProductMaturityPipe
} from './pipes';
import {BackButtonDirective, ClickOutsideDirective, NgModelChangeDebouncedDirective} from './directives';
import {ProductTypePipe} from "./pipes/product-type.pipe";
import {FormatAvailableFundsPipe} from "./pipes/format-avaulable-funds.pipe";
import {QRCodeModule} from "angularx-qrcode";
import {ProductTypeOrSubTypePipe} from "./pipes/product-type-or-sub-type.pipe";

const Modules = [
	MatBadgeModule,
	MatInputModule,
	MatRadioModule,
	MatButtonModule,
	MatSelectModule,
	MatCheckboxModule,
	MatDatepickerModule,
	MatSlideToggleModule,
	MatAutocompleteModule,
	MatDialogModule,
	MatExpansionModule,
	MatListModule,
	QRCodeModule
];

const Pipes = [
	SanitizeHtmlPipe,
	FormatStringPipe,
	FormatDecimalPipe,
	FormatIntegerPipe,
	FormatCurrencyPipe,
	OrderStatusPipe,
	DocumentStatusPipe,
	LinkedAccountStatusPipe,
	IndividualGreetingPipe,
	ProductNamePipe,
	ProductDocumentsPipe,
	PriceTypePipe,
	DocumentIconPipe,
	ImageCdnFilePipe,
	DocumentTypePipe,
	ProductStatusPipe,
	FormatPercentagePipe,
	ProductGroupPipe,
	ProductCategoryPipe,
	ProductUnderlyingsPipe,
	ProductSubTypePipe,
	ProductBarrierTypePipe,
	ProductBarrierFrequencyPipe,
	OptionsWithHitsPipe,
	ProductWarrantTypePipe,
	IsMutualFundsPipe,
	OrderTypePipe,
	ProductCouponPaymentDatePipe,
	ProductMaturityPipe,
	ProductTypePipe,
	FormatAvailableFundsPipe,
	ProductTypeOrSubTypePipe
];

const Directives = [
	ClickOutsideDirective,
	NgModelChangeDebouncedDirective,
	BackButtonDirective
];

const Components = [
	FormComponent,
	AlertComponent,
	SelectComponent,
	CheckboxComponent,
	PreloaderComponent,
	BurgerMenuComponent,
	DatepickerComponent,
	PanelInputComponent,
	RadioGroupComponent,
	AsyncButtonComponent,
	AmountInputComponent,
	SlideToggleComponent,
	AutocompleteComponent,
	PasswordInputComponent,
	UploadDocumentComponent,
	YearDatepickerComponent,
	PhoneAutocompleteComponent,
	LockableDatepickerComponent,
	CountryAutocompleteComponent,
	DialogComponent,
	AlertComponent,
	PaginationComponent,
	StepperComponent,
];

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
	return new TranslateHttpLoader(http);
}

@NgModule({
	imports: [
		HttpClientModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,

		...Modules,

		TranslateModule.forChild({
			defaultLanguage: Language.English,
			useDefaultLang: true,
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
	],
	declarations: [
		...Components,
		...Pipes,
		...Directives,
	],
	exports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule,

		...Modules,

		...Components,
		...Pipes,
		...Directives,
	],
})
export class SharedModule {
}
